var animatedEnterpriseAccounting = function() {
    const modules = document.querySelectorAll('.gg-animated-enterprise-accounting__content:not(.gg-animated-enterprise-accounting-v2)');

    modules.forEach(module => {
        const items = module.querySelectorAll('.gg-animated-enterprise-accounting__item');
        const totalItems = items.length;
        const slideBar = module.querySelector('.gg-animated-enterprise-accounting__slide-bar');
        const itemsCircle = module.querySelector('.gg-animated-enterprise-accounting__item-circle');
        const lineProgress = slideBar.querySelector('.gg-animated-enterprise-accounting__line-progress');
        const groupItemSlide = module.querySelector('.gg-animated-enterprise-accounting__group-item-slide');
        let maxHeight = 0;

        if (groupItemSlide) {
            maxHeight = Math.max(...Array.from(items, item => item.clientHeight));
            groupItemSlide.style.minHeight = `${maxHeight}px`;
        }
        const totalHeight = maxHeight - 30;
        const itemHeight = totalHeight / totalItems;

        const parentModule = module.closest('.gg-animated-enterprise-accounting');

        if (parentModule && window.innerWidth > 1024) {
            const heightModule = (totalHeight * 1.7) * totalItems + window.innerHeight;
            parentModule.style.height = `${heightModule}px`;
        }

        let currentIndex = -1;
        let lastScrollY = window.scrollY;
        let isScrollDown = false;
        let isFirstDisplay = true;
        let indexPrevious = 0;

        const updateVisibleItem = () => {
            if(indexPrevious === currentIndex) {
                return;
            }
            if(currentIndex === (totalItems-1) && indexPrevious === 0 || currentIndex === 0 && indexPrevious === (totalItems-1)) {
                setTimeout(() => {
                    items.forEach((item, index) => {
                        const isCurrent = index === currentIndex;
                        indexPrevious = currentIndex;
                        item.classList.toggle('is-show', isCurrent);
                        
                        if (lineProgress && isCurrent) {
                            lineProgress.style.maxHeight = `${itemHeight * (currentIndex + 1)}px`;
                            itemsCircle.style.animation = isScrollDown ? 
                                `rotateAnimationDown${currentIndex} 1s ease-in-out forwards` : 
                                `rotateAnimationUp${currentIndex} 1s ease-in-out forwards`;
                        }
                    });
                }, 800);
            } else {
                items.forEach((item, index) => {
                    const isCurrent = index === currentIndex;
                    setTimeout(() => {
                        indexPrevious = currentIndex;
                    }, 500)
                    item.classList.toggle('is-show', isCurrent);
                    
                    if (lineProgress && isCurrent) {
                        lineProgress.style.maxHeight = `${itemHeight * (currentIndex + 1)}px`;
                        itemsCircle.style.animation = isScrollDown ? 
                            `rotateAnimationDown${currentIndex} 1s ease-in-out forwards` : 
                            `rotateAnimationUp${currentIndex} 1s ease-in-out forwards`;
                    }
                });
            }
        };

        const handleScroll = () => {
            const stickyPosition = module.getBoundingClientRect().top;
            const groupItemSlide = module.querySelector('.gg-animated-enterprise-accounting__group-item-slide');
            
            if (isFirstDisplay) {
                if (stickyPosition <= window.innerHeight / 2) {
                    currentIndex = 0;
                    groupItemSlide.classList.add('is-scroll-down');
                    updateVisibleItem();
                    isFirstDisplay = false;
                    return;
                } else {
                    return;
                }
            }

            if (window.innerWidth > 1024 && stickyPosition === 0) {
                const scrollPosition = window.scrollY - (window.innerHeight - stickyPosition);
                const getThreshold = (index) => {
                    return index === 0 || index === totalItems - 1 ? totalHeight*1.2 / 3 : totalHeight*1.2;
                };
                const getTotalThreshold = (index) => {
                    let total = parentModule.offsetTop - totalHeight;
                    for (let i = 0; i <= index; i++) {
                        total += getThreshold(i);
                    }
                    return total;
                };
            
                if (scrollPosition >= getTotalThreshold(currentIndex)) {
                    currentIndex = Math.min(currentIndex + 1, totalItems - 1);
                    groupItemSlide.classList.add('is-scroll-down');
                    groupItemSlide.classList.remove('is-scroll-up');
                    isScrollDown = true;
                } 

                else if (currentIndex > 0 && scrollPosition < getTotalThreshold(currentIndex - 1)) {
                    currentIndex = Math.max(currentIndex - 1, 0);
                    groupItemSlide.classList.remove('is-scroll-down');
                    groupItemSlide.classList.add('is-scroll-up');
                    isScrollDown = false;
                }
                updateVisibleItem();
                lastScrollY = scrollPosition;
            }
        };

        window.addEventListener('scroll', handleScroll);
        updateVisibleItem();
    });
};

function debounce(func, wait) {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

const debouncedAnimatedEnterpriseAccounting = debounce(() => {
    if (window.innerWidth > 1024) {
        animatedEnterpriseAccounting();
    }
}, 300);


window.addEventListener('resize', debouncedAnimatedEnterpriseAccounting);

if (window.innerWidth > 1024) {
    animatedEnterpriseAccounting();
}